import { useAct } from 'FlowBuilder/store'
import './TopNav.scoped.scss'
import { toast } from 'react-toastify'

export default function TopNav() {
  const act = useAct()
  const navItem = useSel(s => s.local.navItem)
  const isEditingTemplate = useSel(s => s.local.isEditingTemplate)
  const { systemTemplate } = useSel((s) => s.builder.flowTemplate)
  const buildValidationErrors = useSel((s) => s.builder.validationErrors || [])

  const hasBuildValidationErrors = () => {
    return buildValidationErrors.length > 0
  }

  const changeTab = (newPage) => {
    if (navItem === 'build' && buildValidationErrors.length > 0) {
      buildValidationErrors.forEach(error => {
        toast.error(error)
      })
      return new Error('Build validation errors present')
    }
    act.local.setNav(newPage)
  }

  const tabClasses = (tab) => {
    let classes = ['tab']
    if (navItem === tab) {
      classes.push('selected')
    }
    if (hasBuildValidationErrors() && tab !== 'build') {
      classes.push('disabled')
    }
    return classes.join(' ')
  }

  return <div className='row'>
    <div className='tabs column'>
      { isEditingTemplate && <div className={tabClasses('template')} onClick={() => changeTab('template')}>Template</div> }
      { <div className={tabClasses('setup')} onClick={() => changeTab('setup')}>Setup</div>}
      { <div className={tabClasses('build')} onClick={() => changeTab('build')}>
        Build
        {hasBuildValidationErrors() && <span className="warning-icon"><SvgIconsWarning /></span>}
      </div>}
      <div className={tabClasses('preview')} onClick={() => changeTab('preview')}>Preview</div>
    </div>
  </div>
}
